import { m as missingThemingPaletteError } from './component-errors-b6f1109b.js';

/**
 * Used to add multiple classes to a JSX element. Creates an easier API to add conditional classes alongside strings or other expressions
 * @param klasses A list of classes to be added to the element
 */
function klassList(...klasses) {
  return klasses
    .filter(klass => !!klass)
    .join(' ');
}
/**
 * Will dynamically generate an ID string for elements that require an ID but are not provided one
 */
function idGenerator() {
  return `_${Math.random().toString(36).substr(2)}`;
}
/**
 * Removes orphaned text from an element
 * @param parent The element that contains the orphans you want to remove
 */
function removeOrphanedText(parent) {
  const textOrphans = [...parent.childNodes].filter(node => node.nodeName === '#text');
  textOrphans.forEach(node => node.remove());
}
/**
 * Converts a color heidecimal value to an `rgb` value
 * @param hex The hexidecimal value of the color to convert to `rgb` format
 */
function hexToRgb(hex) {
  if (!hex)
    missingThemingPaletteError();
  const parsedHex = hex.replace(/[^0-9A-Z]/gi, '');
  const r = parseInt(parsedHex.substring(0, 2), 16);
  const g = parseInt(parsedHex.substring(2, 4), 16);
  const b = parseInt(parsedHex.substring(4, 6), 16);
  // return `rgb(${[r, g, b].join(', ')})`;
  return {
    r,
    g,
    b,
  };
}
function createSolidAlphaVariants(color, alpha) {
  const rgb = color
    .replace(/[a-z\(\)\s]/gi, '')
    .split(',')
    .map(str => Math.round((1 - alpha) * 255 + alpha * parseFloat(str)));
  return `rgb(${rgb})`;
}
/**
 * Can be used to adjust the `color` of an element to ensure that proper contrast is met.
 *
 * If you want to use this on an element that has a transition/animation on the `backgroundColor` or `color` properties
 * you will need to wrap this function in a set timeout of `duration + 100` to ensure that it runs after the transition
 * @param target The element that should be evaluated for contrast correcion
 * @example
 * setTimeout(() => {
 *  makeContrastCompliant(targetElement);
 * }, 250)
 */
function makeContrastCompliant(target) {
  var _a, _b, _c;
  if (!window)
    return;
  const { backgroundColor } = getComputedStyle(target);
  const rgb = (_c = (_b = (_a = backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.replace(/[a-z\(\)\s]/gi, '')) === null || _a === void 0 ? void 0 : _a.split(',')) === null || _b === void 0 ? void 0 : _b.map(value => parseInt(value))) !== null && _c !== void 0 ? _c : [0, 0, 0];
  const sum = Math.round((rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000);
  target.style.color = sum > 128 ? `var(--richBlack)` : `var(--white)`;
}
function pushToastNotification(toastConfig) {
  const toast = {
    hostId: toastConfig.hostId,
    message: toastConfig.message || `Enter a message`,
    id: toastConfig.id || idGenerator(),
    color: toastConfig.color || null,
    type: toastConfig.type || `notification`,
  };
  document.dispatchEvent(new CustomEvent(`epi-toast_showNewToast`, { detail: toast }));
}
function getAllElements(startFrom, selector) {
  return [...startFrom.querySelectorAll(selector)].map(el => el);
}
/**
 *
 * @param delay Time in ms to delay the callback execution
 * @param fn The callback to be executed when the timer has completed
 */
function debounce(delay, fn) {
  /** the timer to be used */
  /** return the callback */
  return function (...args) {
    /** if the timer exists clear it */
    // @ts-expect-error
    clearTimeout(window._taskTimer);
    /** set up a timer with the cllback */
    // @ts-expect-error
    window._taskTimer = setTimeout(() => {
      fn(...args);
      // @ts-expect-error
      window._taskTimer = null;
    }, delay);
  };
}
// for (var i = 1; i < 6; i++) {
//   var toast = {
//     message: `toast notification ${i}`,
//     id: i,
//     color: null,
//     type: `notification`,
//   }
//   document.dispatchEvent(new CustomEvent(
//     'epi-toast_showNewToast',
//     { detail: toast }
//   ))
// }

export { createSolidAlphaVariants as c, getAllElements as g, hexToRgb as h, idGenerator as i, klassList as k, makeContrastCompliant as m };
